var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',[_vm._v("\n\tPlease insert the Floppy labeled `"+_vm._s(_vm.floppy)+"` in Drive A:\\\n")])}
var staticRenderFns = []

export { render, staticRenderFns }